import { ECategory } from '../../../node/repositories/offer-card/entities/offer/OfferSchema';
import { EOfferType } from '../../repositories/offer-card/entities/offer/OfferSchema';
import { IState } from '../../store';
import { EDealType } from '../../store/offerHistory';
import { selectOffer, selectOfferAgent, selectUser } from '../offerData';

export const selectIsMortgageBannerEnabled = (state: IState): boolean => {
  const { dealType, offerType, category } = selectOffer(state);
  const user = selectUser(state);
  const agent = selectOfferAgent(state);

  return (
    !agent?.bank &&
    !user?.isAgent &&
    dealType !== EDealType.Rent &&
    offerType !== EOfferType.Commercial &&
    category !== ECategory.LandSale
  );
};
